<template>
  <component :is="collectionData === undefined ? 'div' : 'b-card'">
    <b-alert variant="danger" :show="collectionData === undefined">
      <h4 class="alert-heading">獲取自取卷數據時出錯</h4>
      <div class="alert-body">
        找不到相關自取卷記錄。請查看
        <b-link class="alert-link" :to="{ name: 'collection-list' }">
          自取卷列表
        </b-link>
      </div>
    </b-alert>
    <collection-edit-tab-information
      v-if="collectionData"
      :invoiceOptions="invoiceOptions"
      :customerOptions="customerOptions"
      :voucherStatusOptions="voucherStatusOptions"
      :collection-data="collectionData"
      class="p-sm-2"
      @refetch-data="refetchData"
    />

    <!-- @refetch-data="refetchData" -->
  </component>
</template>

<script>
import { BCard, BAlert, BLink, BTabs, BTab } from "bootstrap-vue";
import { ref, onUnmounted, onMounted } from "@vue/composition-api";
import store from "@/store";
import router from "@/router";
import collectionStoreModule from "../collectionStoreModule";
import collectionEditTabInformation from "./collectionEditTabInformation.vue";

export default {
  components: {
    collectionEditTabInformation,
    BCard,
    BAlert,
    BTabs,
    BTab,
    BLink,
  },
  setup() {
    const collectionData = ref({ id: 0 });
    const collection = {
      id: 0,
    };

    const collection_APP_STORE_MODULE_NAME = "collection";

    if (!store.hasModule(collection_APP_STORE_MODULE_NAME))
      store.registerModule(collection_APP_STORE_MODULE_NAME, collectionStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(collection_APP_STORE_MODULE_NAME))
        store.unregisterModule(collection_APP_STORE_MODULE_NAME);
    });

    const refetchData = () => {
      if (router.currentRoute.name == "coupon-collection-create") {
        collectionData.value = collection;
      } else {
        store
          .dispatch("collection/fetchCollection", {
            id: router.currentRoute.params.id,
          })
          .then((response) => {
            collectionData.value = response.data.collection_voucher;
            console.log(collectionData.value);
          })
          .catch((error) => {
            console.log("error when fetching collection", error);
            if (error.response.status === 404) {
              collectionData.value = undefined;
            }
          });
      }
    };

  const invoiceOptions = ref([]);
  const customerOptions = ref([]);
  const voucherStatusOptions = ref([]);

  const refetchOption = () => {
    store
      .dispatch("app/fetchOptionList", {
        invoices: true,
        customers: true,
        voucher_statuses:true,
      })
      .then((response) => {
        invoiceOptions.value = response.data.invoices;
        customerOptions.value = response.data.customers;
        voucherStatusOptions.value = response.data.voucher_statuses;
        refetchData();
      });
  };

    onMounted(() => {
      refetchOption();
    });

    return {
      collectionData,
      invoiceOptions,
      customerOptions,
      voucherStatusOptions,
      refetchOption,
      refetchData,
    };
  },
};
</script>
